import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { Helper } from 'src/app/shared/utils/helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-print-modal',
  templateUrl: './print-modal.component.html',
  styleUrls: ['./print-modal.component.css']
})
export class PrintModalComponent implements OnInit {
  type: string = null;
  rootUrl = `${environment.rootUrl}/label`;
  printOptions = [];
  public onClose: Subject<any>;
  public windowObjectReference = null; // global variable

  constructor(public bsModalRf: BsModalRef, private toast: ToastrService) { }
  itemId: string = null;
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  onChangeUser(data) {
    if (!Helper.isEmpty(data)) {
      return this.type = data.value
    } else {
      return this.type = null;
    }
  }

  async print() {
    console.log(this.printOptions);
    if (this.printOptions && this.printOptions instanceof Array && this.printOptions.length > 0 && this.type == null) {
      this.type = this.printOptions[0].value;
    }
    if (this.type == null) {
      return this.toast.error("Please select the type");
    }
    if (this.itemId == null || Helper.isEmpty(this.itemId)) {
      return this.toast.error("Invalid Id");
    }
    const url = encodeURI(`${this.rootUrl}/${this.type}?id=${this.itemId}`);
    var printWindow = window.open(url, 'windowFeatures');
    return false;
  }
}
